export default function ToggleButton({ checked = false, onToggle }) {
  
  return (
    <button
      type="button"
      onClick={() => onToggle(!checked)}
      className={`relative inline-flex items-center h-6 w-11 rounded-full transition-colors duration-300 ${checked ? 'bg-green-500' : 'bg-gray-300'}`}
    >
      <span className={`inline-block h-4 w-4 transform bg-white rounded-full transition-transform duration-300 ${checked ? 'translate-x-6' : 'translate-x-1'}`}/>
    </button>
  );
}